// ------SAMPLE CALLS------

import {
  getBranch,
  getKey,
  getToken,
  getUser,
} from "../../../../Components/Helpers/Utilities/Common";
import {
  getAPICall,
  postAPICallwithFile,
  putAPICall,
  postAPICall,
  getWithParamsAPICall,
} from "../../../../Components/Helpers/API/axiosMethodCall";

//POST API -- append a new data to the db
export const createUser = async (data) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "users/create",
      {
        requester: getUser(),
        token: getToken(),
        full_name: data.full_name,
        password: data.password,
        username: data.username,
        role_id: data.role_id,
        role_name: data.role_name,
      }
    );
    return response;
  } catch (error) {
    return { error: error.response };
  }
};

export const getUsers = async (data, ref, num) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
    };

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "users/get",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const getUserID = async (user_id) => {
  try {
    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "users/get",
      {
        requester: getUser(),
        token: getToken(),
        user_id,
      }
    );
    return { data: response.data.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const editUser = async (info) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "users/update",
      {
        requester: getUser(),
        token: getToken(),
        user_id: info.id,
        username: info.username,
        full_name: info.full_name,
        role_id: info.role_id,
        role_name: info.role_name,
      }
    );

    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const editPassword = async (info) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "users/update",
      {
        requester: getUser(),
        token: getToken(),
        username: info.username,
        user_id: info.id,
        password: info.password,
      }
    );

    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const deleteUser = async (id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "users/delete",
      {
        requester: getUser(),
        token: getToken(),
        user_id: id,
      }
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};
